import { CommonPlayerEventParams } from '../useCommonPlayerEventParams';
import { useTriggerOnPlayerEvent } from '../useTriggerOnPlayerEvent';

export const useTriggerOnPlaybackUnpause = (params: CommonPlayerEventParams) =>
    useTriggerOnPlayerEvent(params, 'PLAYBACK_UNPAUSE');
